import usePlacesAutocompleteInput from 'use-places-autocomplete';

export function useGoogleMaps() {
  const {
    ready,
    value,
    suggestions: { status, data, loading },
    setValue,
  } = usePlacesAutocompleteInput({
    requestOptions: {
      /* Define search scope here */
      types: ['address'],
    },
    debounce: 300,
  });

  return { data, value, setValue, loading: !ready || loading || !status };
}
